import { Component, OnInit, NgZone, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Hub } from 'aws-amplify/utils';
import { fetchAuthSession, fetchUserAttributes, signOut } from 'aws-amplify/auth';
import { environment } from '@environments/environment';
import { AuthService } from '@shared/services/guards/auth.service';
import { RouteService } from '@shared/services/guards/route.service';
import { AdminService } from '@shared/services/admin.service';
import { ServiceRequestService } from '@app/shared/services/service-request.service';
import { AmplifyAuthService } from '@app/shared/services/amplifyAuth.service';

@Injectable({
    providedIn: 'root'
})

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

    loading = false;
    prevURL = localStorage.getItem('prev_url')
    constructor(
        private router: Router,
        private routeService: RouteService,
        private authService: AuthService,
        private ngZone: NgZone,
        private requestService: ServiceRequestService,
        private adminService: AdminService,
        private amplifyAuthService: AmplifyAuthService
    ) {}

    ngOnInit() {
        const prevUrl = this.routeService.getPreviousUrl();

        if (prevUrl === '/login') {
            this.routing();
            return;
        }
        else
        {
            this.loading = true;
            Hub.listen('auth', (data) => {
                switch (data.payload.event) {
                    case 'signedIn':
                        console.log('now the user is signed in');
                        localStorage.setItem('isLoggedIn', 'true')
                        this.routing();
                        break;
                    case 'signInWithRedirect_failure':
                        console.log('now the user is fail in');
                        localStorage.setItem('isLoggedIn', 'false')
                        this.routing();
                        break;
                    default:
                        break;
                }
            });
        }
        
    }

    routing() {

        this.authService
            .isVerified()
            .subscribe(
                data => {

                    this.adminService.monitorViolationStatus().subscribe(resp => {
                        console.log("RESP Violation", resp)
                    });

                    this.requestService.monitorReworkRate().subscribe(resp => {
                        console.log("RESP Rework Rate", resp)
                    });

                    this.validateUserInPool(data)
                },
                err => {
                    this.update(false, '')
                }
            );

    }

    async update(isAuthenticated, userType) {

        this.amplifyAuthService.fetchUserAttributes().then( async (data) => {
            const userEmail = data.email;
            // const token = localStorage.getItem('token');
            const token = (await this.amplifyAuthService.fetchAuthSession()).tokens.idToken.toString();

            const loginStatus = localStorage.getItem('isLoggedIn');

            localStorage.setItem('userType', userType);
            localStorage.setItem('userEmail', userEmail);

        //    this.storeToken(userEmail, token, loginStatus);

        this.requestService.storeLoginToken(userEmail, token, loginStatus).subscribe(
            data => {
                if (isAuthenticated && (userType == "CustomerCareRepresentative" || userType == "BIZPartnerManager")) {

                    if (this.prevURL !== undefined && this.prevURL !== '/' ) {
                        console.log("OPTION 1")
                        localStorage.removeItem('prev_url');
                        this.ngZone.run(() => this.router.navigateByUrl(this.prevURL));
                    } else {
                        console.log('OPTION 2')
                        localStorage.removeItem('prev_url')
                        this.ngZone.run(() => this.router.navigate([environment.frontliner_home]))
                    }

                }
                else if (isAuthenticated && userType == "SystemAdministrator") {
                    if (this.prevURL != undefined && this.prevURL != '/user/search') 
                    {
                        localStorage.removeItem('prev_url')
                        this.ngZone.run(() => this.router.navigateByUrl(this.prevURL))
                    } 
                    else 
                    {
                        localStorage.removeItem('prev_url')
                        this.ngZone.run(() => this.router.navigate([environment.systemAdmin_home]));
                    }
                }
                else 
                {
                    // CLEAR STORAGE AND REDIRECT
                    this.amplifyAuthService.signOut()
                    localStorage.clear();
                    // window.location.replace(environment.signOut);
                }
            },
            error => {
                this.amplifyAuthService.signOut()
                localStorage.clear();
            }
        );

        })
    
    
}

  /*validateUserInPool(data){

    console.log("ENTERED VALIDATION")
  
    let loginEmail = data.attributes.email

    
      localStorage.setItem("initEmail", loginEmail)
     
        console.log("TOKEN SAVED")
       
        this.adminService.getUser(loginEmail).subscribe(profile =>{
          console.log("ENTERED ADMIN GETUSER")
          if(profile['body']['profile_id'] != null)
          {
            localStorage.setItem('userProfileTag', String(profile['body']['profile_id']))
          }
              let loginUserType = profile['body']['userType'] //for Frontliner view
              //let loginUserType = "SystemAdministrator";
    
              this.update(true, loginUserType)
              
        },
        error => {
            this.update(false, '')
          }
        )
  }*/

    validateUserInPool(data) {
        const loginEmail = data.email;
        this.adminService
            .getUser(loginEmail)
            .subscribe(
                profile => {
                    if (profile['body']['profile_id'] != null) {
                        localStorage.setItem('userProfileTag', String(profile['body']['profile_id']))
                    }
                    if (profile['body']['officeAssignment']['value'] != null) {
                        localStorage.setItem('userOfficeAssignment', JSON.stringify(profile['body']['officeAssignment']))
                    }
                    let loginUserType = profile['body']['userType'] //for Frontliner view
                    //let loginUserType = "SystemAdministrator";
                    this.update(true, loginUserType)
                },
                error => {
                    this.update(false, '')
                }
            )
    }

    storeToken(email: string, token: string, isLogged: string) {
        this.requestService
            .storeLoginToken(email, token, isLogged)
            .subscribe(
                data => {},
                error => {
                    console.log('error');
                }
            );
    }
}
